"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Builder = function Builder(props) {
  var content = props.fields.content;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
    field: content,
    label: "Label:"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
    content: content.value,
    onChange: content.onChange,
    type: "textarea-inline"
  })));
};
Builder.propTypes = {
  fields: _propTypes["default"].object
};
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues
})(Builder);